<div class="loading-overlay">
    <div class="loading-overlay-content">
        <ng-content></ng-content>
    </div>
    <div [ngClass]="'loading-overlay-layer-overlay'" [@loading]="state">
        <div class="spinner">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
        </div>
    </div>
</div>
<!--<div class="loading-overlay-spinner"></div>-->